import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { makeGetDoc } from '../selectors/docs';
import { makeGetCurrentUserId } from '../selectors/users';

import { addDocMembers, removeDocMembers } from '../actions/docs';

import { docPermissions, userRoles } from '../constants';

import { trackEvent } from '../services/events-tracker-service';
import { getDocPermissionLabel } from '../utils/user';

import UserFaces from './user-faces';
import UserPermissionSelector from './user-permission-selector';
import AddUserPopout from './add-user-popout';

import IconArrowDown from '../icons/icon-arrow-down';
import IconInvite from '../icons/icon-invite';

const docPermissionsCollection = docPermissions();

class DocumentUsers extends PureComponent {
    static defaultProps = {
        size: 'medium',
        editableAssignees: true
    }

    state = {
        selectedUser: null
    };

    handleUserClick = (userId, event) => {
        this.setState({
            selectedUser: userId
        }, () => {
            this.userPermissionCtrl && this.userPermissionCtrl.show(event);
        });
    }

    handleUserPermissionSelectorHide = () => {
        this.setState({
            selectedUser: null
        });
    }

    handleUserPermissionChange = (userId, permission) => {
        addDocMembers(this.props.id, [{ id: userId, permission }]);
    }

    handleUserRemove = userId => {
        removeDocMembers(this.props.id, [ userId ]);
    }

    handleUserInvite = ({ id, permission }) => {
        addDocMembers(this.props.id, [{ id, permission }]);
        trackEvent('DOC.USERS_ASSIGN', { permission });
    }

    get permission() {
        if (this.props.doc.author === this.props.currentUserId) {
            return 'edit';
        }

        const user = this.props.members.find(user => user.id === this.props.currentUserId);
        return user && user.permission;
    }

    get currentUserCanEdit() {
        return this.permission === 'edit' && this.props.editableAssignees;
    }

    get isInternal() {
        return this.props.doc && this.props.doc.type === 'nifty';
    }

    render() {
        return (
            <div className="users-list-component">
                {
                    this.currentUserCanEdit &&
                        <React.Fragment>
                            <UserFaces
                                users={this.props.members.map(user => user.id)}
                                size={this.props.size}
                                maxUsersCount={4}
                                subtitles={!this.isInternal ? [] : this.props.members.map(user => ({id: user.id, subtitle: getDocPermissionLabel(user.permission)}))}
                                subtitleIcon={<IconArrowDown size="8px" style={{ position: 'relative', top: '-1px' }} />}
                                additionals={this.props.members.map(user => {
                                    const lastSeen = user.last_seen && moment(user.last_seen);
                                    return {
                                        id: user.id,
                                        additional: lastSeen && lastSeen.isValid() ? `Viewed ${lastSeen.fromNow()}` : null
                                    }
                                })}
                                onSubtitleClick={this.handleUserClick}
                                onClick={this.handleUserClick}
                            />

                            {
                                this.state.selectedUser ? (
                                    <UserPermissionSelector
                                        provideController={ctrl => this.userPermissionCtrl = ctrl}
                                        userId={this.state.selectedUser}
                                        permission={this.props.members.find(user => user.id === this.state.selectedUser).permission}
                                        permissions={docPermissionsCollection}
                                        onRemove={this.handleUserRemove}
                                        onSuccess={this.handleUserPermissionChange}
                                        onHide={this.handleUserPermissionSelectorHide}
                                    />
                                ) : null
                            }
                        </React.Fragment>
                }

                {
                    !this.currentUserCanEdit &&
                        <UserFaces
                            size={this.props.size}
                            users={this.props.members.map(user => user.id)}
                            subtitles={!this.isInternal ? [] : this.props.members.map(user => ({id: user.id, subtitle: getDocPermissionLabel(user.permission)}))}
                            additionals={this.props.members.map(user => ({id: user.id, additional: `Viewed ${moment(user.last_seen).fromNow()}`}))}
                        />
                }

                {
                    this.currentUserCanEdit &&
                        <div className="add-user">
                            <AddUserPopout
                                title="ADD USER TO DOC:"
                                projectId={this.props.doc && this.props.doc.project}
                                onUserSelect={this.handleUserInvite}
                                roles={userRoles()}
                                emailMatchText="Select user role above and click “Invite” below and we’ll shoot this person an email notifying them that they’ve been added to this doc."
                                noMatchText="Looks like that person isn’t a member yet. Enter their email address to add them to the doc and project."
                                excludedUsers={this.props.members.map(user => user.id)}
                                permissions={this.props.doc.access_type !== 'public' && docPermissionsCollection}
                                onShow={this.props.onPopoutShow}
                                onHide={this.props.onPopoutHide}
                            >
                                <button className={`btn btn-simple btn-${this.props.size} btn-square btn-icon btn-colored`}>
                                    <IconInvite />
                                </button>
                            </AddUserPopout>
                        </div>
                }
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentUserId = makeGetCurrentUserId();
    const getDoc = makeGetDoc();

    return ({ docs, users }, ownProps) => {
        const doc = getDoc(docs.items, ownProps.id);

        return {
            currentUserId: getCurrentUserId(users),
            members: (doc && doc.members) ? doc.members : [],
            doc
        }
    };    
}

export default connect(makeMapStateToProps)(DocumentUsers);
